<template>
  <transition name="fade" mode="out-in" tag="div">
    <div class="multiselect-wrapper">

      <multiselect id="ajax" label="name" track-by="code" placeholder="Zoeken" open-direction="bottom"
                   :options="options" :noOptions="noOptions" :selectLabel="selectLabel" :show-labels="false" :searchable="true"
                   :loading="isLoading" :internal-search="false" :clear-on-select="false" :close-on-select="true"
                   :options-limit="300" :limit="3" :limit-text="limitText" :max-height="600" :hide-selected="true"
                   @search-change="asyncFind" @select="click" @close="close">
        <template slot="option" slot-scope="props">
          <div class="option__desc">
            <div class="option__small">{{ props.option.type }}</div>
            <div class="option__title">{{ props.option.number }}{{ props.option.code }} {{ props.option.name }}</div>
          </div>
        </template>
        <span slot="noResult">{{noOptions}}</span>
        <span slot="noOptions">{{noOptions}}</span>
      </multiselect>

    </div>
  </transition>
</template>

<script lang="ts">
  import { Vue, Watch, Prop, Component } from 'vue-property-decorator';
  import Multiselect from 'vue-multiselect';
  import axios from 'axios';


  // COMPONENTS
  @Component({
    components: {
      Multiselect,
    },
  })

  export default class Search extends Vue {
    public minSearchLength = 2;
    public isLoading = false;
    public options = [];
    public uuidRegex = '=([a-zA-Z0-9]{8}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{12})';
    public timer: number|undefined = undefined;

    get selectLabel() {
      return 'Druk op enter om te kiezen';
    }

    get noOptions() {
      return 'Geen resultaten gevonden.';
    }

    public close() {
      this.options = [];
    }

    get userOrganization() {
      return this.$store.getters.getUser.organization;
    }

    public limitText(count: number) {
      return `en ${count} andere resultaten`;
    }

    public click(value: any) {
      switch (value.type.toLowerCase()) {
        case 'commercial partner':
        case 'service partner':
        case 'go partner':
          this.$router.push({
            name: 'partners.edit',
            params: {
              pid: value.id,
            },
          });
          break;
        case 'klant':
          this.$router.push({
            name: 'customers.edit',
            params: {
              id: value.id,
            },
          });
          break;
        case 'gebruiker':
          this.determineOrganizationTypeAndPushToCorrectUserRoute(value);
          break;
        case 'contact':
          this.determineOrganizationTypeAndPushToCorrectContactRoute(value);
          break;
        case 'agreement':
          this.$router.push({
            name: 'partners.agreements.edit',
            params: {
              pid: value.partnerId,
              paid: value.id,
            },
          });
          break;
        case 'quote':
          this.$router.push({
            name: 'quotes.edit',
            params: {
              id: value.id,
            },
          });
          break;
        case 'order':
          this.$router.push({
            name: 'orders.orderlines',
            params: {
              transactionId: value.id,
            },
          });
          break;
        default:
          // TODO handle
          break;
      }
    }

    public determineOrganizationTypeAndPushToCorrectContactRoute(selectedEntity: any) {
      const requestData = {
        id: selectedEntity.orgId,
      };

      axios.post('/-/trade/api/person.info', requestData)
        .then(
          (organization: any) => {
            if (
                this.userOrganization
                && this.userOrganization.isProvider
                && this.userOrganization.id !== selectedEntity.orgId
                && organization.data.isPartner
            ) {
              return this.$router.push({
                name: 'partner.contact.edit',
                params: {
                  contactId: selectedEntity.id,
                  pid: selectedEntity.orgId,
                },
              });
            }

            if (organization.data.isCustomer) {
              return this.$router.push({
                name: 'customer.contact.edit',
                params: {
                  contactId: selectedEntity.id,
                  pid: selectedEntity.orgId,
                },
              });
            }

            return this.$router.push({
              name: 'profile.contact.edit',
              params: {
                id: selectedEntity.id,
              },
            });
          },
          (error: any) => {
            this.$toast(this.$store.state.main.notification.messages.couldNotReceiveData);
          },
        );
    }

    public determineOrganizationTypeAndPushToCorrectUserRoute(selectedEntity: any) {
      const requestData = {
        id: selectedEntity.orgId,
      };

      axios.post('/-/trade/api/person.info', requestData)
        .then(
          (organization: any) => {
            if (
                this.userOrganization
                && this.userOrganization.isProvider
                && this.userOrganization.id !== selectedEntity.orgId
                && organization.data.isPartner
            ) {
              return this.$router.push({
                name: 'partner.user.edit',
                params: {
                  userId: selectedEntity.id,
                  pid: selectedEntity.orgId,
                },
              });
            }

            return this.$router.push({
              name: 'profile.user.edit',
              params: {
                id: selectedEntity.id,
              },
            });
          },
          (error: any) => {
            this.$toast(this.$store.state.main.notification.messages.couldNotReceiveData);
          },
        );
    }

    public asyncFind(query: string) {
      if (this.timer) {
        clearTimeout(this.timer);
      }

      if (query.search(/\+/g) !== -1) {
        query = query.replace(/\+/g, '');
      }

      if (query.length >= this.minSearchLength) {
        this.timer = setTimeout(() => {
          this.isLoading = true;
          axios
            .post('/-/trade/api/search', {
                query,
            }).then(
            (response) => {
              this.options = response.data;
            },
            (error) => {
              // tslint:disable-next-line:no-console
              console.error(error);
            },
          ).finally(() => {
            this.isLoading = false;
          });
        }, 1000);
      }
    }
  }
</script>

<style lang="scss" scoped>
  // IMPORT
  @import '~@deanone/dean-components/src/scss/vars';

  .multiselect-wrapper {
    height: 100%;
    display: flex;
    align-items: center;
    padding: 0 20px;

    :deep(.multiselect__option--highlight) {
      background: var(--color-primary, $color-primary);
    }
  }
</style>
